import * as React from "react";
import { RiskFactor } from "@/common/js/constant";
import { highlightMarkerSafe } from "@/utils/highlight";
import { trackEvent } from "@/utils/omega";

// 页面参数
type SwitchFactorProps = {
  detail: SwitchVerifyDetail;
  minHeight?: number;
  onSelect: (factor: RiskFactor) => void;
  onCancel?: (cancelByUser: boolean | undefined) => void;
};

export default function SwitchFactor(props: SwitchFactorProps) {
  // 用户取消
  const handleCancel = (cancelByUser?: boolean) => {
    if (cancelByUser) {
      // 上报埋点
      trackEvent("fin_sofi_verification_captcha_popup_ck", {
        button_name: "off",
      });
    }
    props.onCancel && props.onCancel(cancelByUser);
  };
  //
  const handleSelect = (factor: RiskFactor) => {
    // 上报埋点
    trackEvent("fin_sofi_verification_captcha_popup_ck", {
      button_name: factor,
    });
    props.onSelect(factor);
  };

  // 高亮内容
  const highlightHtml = (remark: string) => highlightMarkerSafe(remark);

  // did mount
  React.useEffect(() => {
    // 设置pub page
    // setCommonAttrs({ pub_page: "fin_sofi_verification_captcha_popup"});
    // 上报埋点
    trackEvent("fin_sofi_verification_captcha_popup_sw", {});
  }, []);

  return (
    <div
      className="switch-factor"
      style={props.minHeight ? { minHeight: `${props.minHeight}px` } : undefined}
    >
      <h1>{props.detail.switchVerifyDetail?.title}</h1>
      <div className="switch-factor-content">
        {props.detail.switchVerifyDetail?.switchVerifyList.map((item, index) => {
          return (
            <div className="switch-factor-list" key={index}>
              <p dangerouslySetInnerHTML={{ __html: highlightHtml(item.title) }}></p>
              <div className="btn-group">
                <div
                  className={`btn-confirm`}
                  onClick={handleSelect.bind(null, item.name)}
                  style={{ backgroundColor: item.bgColor, color: item.buttonTitleColor }}
                >
                  {item.buttonImg ? (
                    <img alt="" className="btn-icon" src={`${item.buttonImg}`} />
                  ) : null}
                  {item.buttonTitle}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <span className="btn-close" onClick={handleCancel.bind(null, true)}></span>
    </div>
  );
}
